import { render, staticRenderFns } from "./ToppingsByProductId.vue?vue&type=template&id=6d1c9a0b"
import script from "./ToppingsByProductId.vue?vue&type=script&lang=js"
export * from "./ToppingsByProductId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports